import { useEffect, useRef, useState } from "react";
import * as api from "./api";
import { errorText } from "../../inquiry/v6Api";
import { toParams } from "./logic";

const KW_TOP = 500; // 고유 키워드 수를 세려고 넉넉히 받고 구름에는 앞 24개만

// 목록·건수·키워드를 거르기에 맞춰 읽는다. 거르기가 빨리 바뀌면 늦게 온 옛 응답은 버린다.
export default function useChatData(filter, page, mode, refreshKey) {
    const [list, setList] = useState(null);
    const [counts, setCounts] = useState(null);
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const [kw, setKw] = useState({ items: null, error: "" });
    const seq = useRef(0);
    const kwSeq = useRef(0);

    useEffect(() => {
        const my = ++seq.current;
        setLoading(true);
        const mine = () => my === seq.current;
        const l = api.listSessions(toParams(filter, page))
            .then((r) => { if (mine()) { setList(r); setErr(""); } })
            .catch((e) => { if (mine()) setErr(errorText(e)); });
        // 칩 숫자는 목록을 기다리지 않는다
        api.countSessions(toParams(filter)).then((c) => { if (mine()) setCounts(c); }).catch(() => {});
        l.finally(() => { if (mine()) setLoading(false); });
    }, [filter, page, refreshKey]);

    useEffect(() => {
        if (mode !== "kw") return;
        const my = ++kwSeq.current;
        setKw({ items: null, error: "" });
        api.wordcloud(toParams(filter), KW_TOP)
            .then((r) => { if (my === kwSeq.current) setKw({ items: r.items || [], error: "" }); })
            .catch((e) => { if (my === kwSeq.current) setKw({ items: null, error: errorText(e) }); });
    }, [filter, mode, refreshKey]);

    return { list, counts, err, loading, kw };
}
